import script from "./PersonalStatisticsProgressView.vue?vue&type=script&setup=true&lang=js"
export * from "./PersonalStatisticsProgressView.vue?vue&type=script&setup=true&lang=js"

import "./PersonalStatisticsProgressView.vue?vue&type=style&index=0&id=958884aa&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-958884aa"]])

export default __exports__